module.exports = __webpack_public_path__ + "images/icons/flags/RU-f93e4e2a.svg";